// src/redux/userSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async thunk for fetching Home data
export const fetchHomepage = createAsyncThunk(
  "content/fetchFeatures",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        "https://backoffice.holybrookstransportation.com/api/request/home-page"
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching Home data:", error);
      return rejectWithValue(
        error.response?.data || "An error occurred while fetching Home data"
      );
    }
  }
);


export const fetcAboutpage = createAsyncThunk(
  "content/fetcAboutpage",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        "https://backoffice.holybrookstransportation.com/api/request/about-us"
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching Home data:", error);
      return rejectWithValue(
        error.response?.data || "An error occurred while fetching Home data"
      );
    }
  }
);


export const fetchBlogDetails = createAsyncThunk(
  "content/fetchBlogDetails",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `https://backoffice.holybrookstransportation.com/api/request/insight/details/${id}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching project details:", error);
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while fetching project details"
      );
    }
  }
);
 

export const fetchBlogpage = createAsyncThunk(
  "content/fetchBlogpage",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        "https://backoffice.holybrookstransportation.com/api/request/insight"
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching Home data:", error);
      return rejectWithValue(
        error.response?.data || "An error occurred while fetching Home data"
      );
    }
  }
);

export const fetchContactPage = createAsyncThunk(
  "content/fetchContactPage",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        "https://backoffice.holybrookstransportation.com/api/request/contact-us"
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching Home data:", error);
      return rejectWithValue(
        error.response?.data || "An error occurred while fetching Home data"
      );
    }
  }
);

export const fetchGeneralPage= createAsyncThunk(
  "content/fetchGeneralPage",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        "https://backoffice.holybrookstransportation.com/api/request/general-settings"
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching Home data:", error);
      return rejectWithValue(
        error.response?.data || "An error occurred while fetching Home data"
      );
    }
  }
);





export const fetchServices = createAsyncThunk(
  "content/fetchServices",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        "https://backoffice.holybrookstransportation.com/api/request/services"
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching Home data:", error);
      return rejectWithValue(
        error.response?.data || "An error occurred while fetching Home data"
      );
    }
  }
);

export const fetchServicesDetails = createAsyncThunk(
  "content/fetchServicesDetails",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `https://backoffice.holybrookstransportation.com/api/request/services/details/${id}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching project details:", error);
      return rejectWithValue(
        error.response?.data ||
          "An error occurred while fetching project details"
      );
    }
  }
);

export const submitContactForm = createAsyncThunk(
  'contact/submitContactForm',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        'https://backoffice.holybrookstransportation.com/api/request/contact-us',
        formData,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Something went wrong.'
      );
    }
  }
);


export const fetchTestimonials = createAsyncThunk(
  "content/fetchTestimonials",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        "https://backoffice.holybrookstransportation.com/api/request/testimonies"
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching Home data:", error);
      return rejectWithValue(
        error.response?.data || "An error occurred while fetching Home data"
      );
    }
  }
);




const homeSlice = createSlice({
  name: "features",
  initialState: {
    data: null,
    homeObject: null,
    contactObject: null,
    currentPage: 1,
    currentBlogPage: 1,
    totalBlogPages: 1,
    totalPages: 1,
    testimonialObject: null,
    aboutObject: null,
    blogDetail: null,
    pricing: null,
    serviceDetails: null,
    serviceObject: null,
    blogObject: null,
    generalObject: null,
    contactObject: null,
    blogCategory: null,
    loading: false,
    successMessage: null,
    contactLoading: false,
    error: null,
  },
  reducers: {
    resetMessage: (state) => {
      state.successMessage = null
    }
  }, // No synchronous reducers
  extraReducers: (builder) => {
    builder
      // Fetch Home Data
      .addCase(fetchHomepage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchHomepage.fulfilled, (state, action) => {
        state.loading = false;
        state.homeObject = action.payload;
      })
      .addCase(fetchHomepage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

     


 builder
      // Fetch Home Data
      .addCase(fetchServices.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchServices.fulfilled, (state, action) => {
        state.loading = false;
        state.serviceObject = action.payload;
      })
      .addCase(fetchServices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

       builder
      // Fetch Home Data
      .addCase(fetchServicesDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchServicesDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.serviceDetails = action.payload;
      })
      .addCase(fetchServicesDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });


      
    builder
      // Fetch Home Data
      .addCase(fetcAboutpage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetcAboutpage.fulfilled, (state, action) => {
        state.loading = false;
        state.aboutObject = action.payload;
      })
      .addCase(fetcAboutpage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

       builder
      // Fetch Home Data
      .addCase(fetchTestimonials.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTestimonials.fulfilled, (state, action) => {
        state.loading = false;
        state.testimonialObject = action.payload;
      })
      .addCase(fetchTestimonials.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      // Fetch Home Data
      .addCase(fetchBlogpage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBlogpage.fulfilled, (state, action) => {
        state.loading = false;
        state.blogObject = action?.payload

      })
      .addCase(fetchBlogpage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

   

    builder
      // Fetch Home Data
      .addCase(fetchBlogDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBlogDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.blogDetail = action.payload;
      })
      .addCase(fetchBlogDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });


          builder
      // Fetch Home Data
      .addCase(fetchContactPage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchContactPage.fulfilled, (state, action) => {
        state.loading = false;
        state.contactObject = action.payload;
      })
      .addCase(fetchContactPage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

          builder
      // Fetch Home Data
      .addCase(fetchGeneralPage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGeneralPage.fulfilled, (state, action) => {
        state.loading = false;
        state.generalObject = action.payload;
      })
      .addCase(fetchGeneralPage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });


  


        builder
      .addCase(submitContactForm.pending, (state) => {
        state.contactLoading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(submitContactForm.fulfilled, (state, action) => {
        state.contactLoading = false;
        state.success = true;
        state.successMessage = action.payload.message 
      })
      .addCase(submitContactForm.rejected, (state, action) => {
        state.contactLoading = false;
        state.error = action.payload || 'Failed to send message.';
      });
  },
});
export const {resetMessage} = homeSlice.actions
export default homeSlice.reducer;
